import React from "react";
import AnimatedSvgThing from "../../animatedSvgBits/AnimatedSvgThing";
import AnimatedSvgGroup from "../../animatedSvgBits/AnimatedGroup";

export default function TapeWheels({
  progress,
  timings,
  totalSpoolRotations,
  isTransparent,
}) {
  // small wheels
  const totalSmallWheelRotations = totalSpoolRotations * 4;
  let maxSmallWheelRotation = totalSmallWheelRotations * 360;

  let forwardsRotationSmall = progress * maxSmallWheelRotation;
  if (isNaN(forwardsRotationSmall)) {
    forwardsRotationSmall = 0;
  }

  const backwardsRotationSmall = -forwardsRotationSmall;

  // big wheels
  const totalBigWheelRotations = totalSpoolRotations * 2;
  let maxBigWheelRotations = totalBigWheelRotations * 360;

  let forwardsRotationBig = progress * maxBigWheelRotations;
  if (isNaN(forwardsRotationBig)) {
    forwardsRotationBig = 0;
  }

  const backwardsRotationBig = -forwardsRotationBig;

  return (
    <g
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      color="#000"
      paintOrder="markers fill stroke"
      transform={`translate(-1, 0)`}
    >
      <g transform={`scale(1.7) translate(-44, -57)`}>
        {/* RIGHT 3 */}
        <g strokeOpacity="0.702" transform="translate(285.46 -73.875)">
          <g transform={`rotate(${forwardsRotationSmall} -143.584 203.965)`}>
            <AnimatedSvgThing
              className={`tapeComponent ${isTransparent && "transparent"}`}
              type="circle"
              timings={timings}
              progress={progress}
              cx="-143.584"
              cy="203.965"
              r="5.055"
              fill="#c8c1be"
              stroke="#4d4d4d"
              strokeWidth="0.529"
            />
            <AnimatedSvgThing
              className={`tapeComponent ${isTransparent && "transparent"}`}
              type="circle"
              timings={timings}
              progress={progress}
              cx="-143.584"
              cy="203.965"
              r="3.26"
              fill="#978c88"
              stroke="#333"
              strokeMiterlimit="4"
              strokeWidth="0.265"
            />
            <AnimatedSvgThing
              className={`tapeComponent ${isTransparent && "transparent"}`}
              type="circle"
              timings={timings}
              progress={progress}
              cx="-143.584"
              cy="-203.965"
              r="1.323"
              fill="url(#wheelScrewHead)"
              stroke="#333"
              strokeMiterlimit="4"
              strokeWidth="0.265"
              transform="scale(1 -1)"
            />
            <use strokeWidth="0.265" xlinkHref="#path1142" />
          </g>
        </g>
      </g>

      {/* RIGHT 4 */}
      <g transform={`scale(1.8) translate(-45, -67)`}>
        <g transform="rotate(30 -112.621 -98.564)">
          <g>
            <g
              strokeOpacity="0.702"
              transform={`translate(1.587 -.53) rotate(${backwardsRotationBig} 238.497 -18.811)`}
            >
              <AnimatedSvgThing
                className={`tapeComponent ${isTransparent && "transparent"}`}
                type="circle"
                timings={timings}
                progress={progress}
                cx="238.497"
                cy="-18.811"
                r="8.797"
                fill="#c8c1be"
                stroke="#4d4d4d"
                strokeWidth="0.529"
              />
              <AnimatedSvgThing
                className={`tapeComponent ${isTransparent && "transparent"}`}
                type="circle"
                timings={timings}
                progress={progress}
                cx="238.497"
                cy="-18.811"
                r="5.673"
                fill="#978c88"
                stroke="#333"
                strokeMiterlimit="4"
                strokeWidth="0.265"
              />
              <g strokeMiterlimit="4" strokeWidth="0.265">
                <AnimatedSvgThing
                  className={`tapeComponent ${isTransparent && "transparent"}`}
                  type="circle"
                  timings={timings}
                  progress={progress}
                  cx="238.497"
                  cy="-18.811"
                  r="1.323"
                  fill="url(#wheelScrewHead)"
                  stroke="#333"
                />
                <use xlinkHref="#path1235" />
              </g>
            </g>

            <AnimatedSvgGroup
              className={`tapeComponent ${isTransparent && "transparent"}`}
              timings={timings}
              progress={progress}
              transform={`rotate(${backwardsRotationBig} 240.1 -19.3)`}
            >
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1256"
              />
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1258"
              />
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1260"
              />
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1262"
              />
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1264"
              />
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1266"
              />
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1268"
              />
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1270"
              />
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1272"
              />
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1274"
              />
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1276"
              />
              <use
                strokeLinecap="round"
                strokeWidth="0.529"
                xlinkHref="#path1278"
              />
            </AnimatedSvgGroup>
          </g>
        </g>
      </g>

      <g transform={`scale(1.7) translate(-50, -57)`}>
        {/* LEFT 3 */}
        <g strokeOpacity="0.702" transform="matrix(-1 0 0 1 -54.885 -73.875)">
          <g transform={`rotate(${backwardsRotationSmall} -143.584 203.965)`}>
            <AnimatedSvgThing
              className={`tapeComponent ${isTransparent && "transparent"}`}
              type="circle"
              timings={timings}
              progress={progress}
              cx="-143.584"
              cy="203.965"
              r="5.055"
              fill="#c8c1be"
              stroke="#4d4d4d"
              strokeWidth="0.529"
            />
            <AnimatedSvgThing
              className={`tapeComponent ${isTransparent && "transparent"}`}
              type="circle"
              timings={timings}
              progress={progress}
              cx="-143.584"
              cy="203.965"
              r="3.26"
              fill="#978c88"
              stroke="#333"
              strokeMiterlimit="4"
              strokeWidth="0.265"
            />
            <AnimatedSvgThing
              className={`tapeComponent ${isTransparent && "transparent"}`}
              type="circle"
              timings={timings}
              progress={progress}
              cx="-143.584"
              cy="-203.965"
              r="1.323"
              fill="url(#wheelScrewHead)"
              stroke="#333"
              strokeMiterlimit="4"
              strokeWidth="0.265"
              transform="scale(1 -1)"
            />
            <use
              strokeMiterlimit="4"
              strokeWidth="0.265"
              xlinkHref="#path1142"
            />
          </g>
        </g>
      </g>

      <g transform={`scale(1.8) translate(-57, -67)`}>
        {/* LEFT 4 */}
        <g transform="scale(-1 1) rotate(30 -227.909 -528.822)">
          <g>
            <g strokeOpacity="0.702" transform="translate(1.587 -.53)">
              <AnimatedSvgThing
                className={`tapeComponent ${isTransparent && "transparent"}`}
                type="circle"
                timings={timings}
                progress={progress}
                cx="238.497"
                cy="-18.811"
                r="8.797"
                fill="#c8c1be"
                stroke="#4d4d4d"
                strokeWidth="0.529"
              />
              <AnimatedSvgThing
                className={`tapeComponent ${isTransparent && "transparent"}`}
                type="circle"
                timings={timings}
                progress={progress}
                cx="238.497"
                cy="-18.811"
                r="5.673"
                fill="#978c88"
                stroke="#333"
                strokeMiterlimit="4"
                strokeWidth="0.265"
              />
              <g
                strokeMiterlimit="4"
                strokeWidth="0.265"
                transform={`rotate(${forwardsRotationBig} 238.497 -18.811)`}
              >
                <AnimatedSvgThing
                  className={`tapeComponent ${isTransparent && "transparent"}`}
                  type="circle"
                  timings={timings}
                  progress={progress}
                  cx="238.497"
                  cy="-18.811"
                  r="1.323"
                  fill="url(#wheelScrewHead)"
                  stroke="#333"
                />
                <use xlinkHref="#path1235" />
              </g>
            </g>
            <AnimatedSvgGroup
              className={`tapeComponent ${isTransparent && "transparent"}`}
              timings={timings}
              progress={progress}
              transform={`rotate(${forwardsRotationBig} 240.1 -19.3)`}
            >
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1256"
              />
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1258"
              />
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1260"
              />
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1262"
              />
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1264"
              />
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1266"
              />
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1268"
              />
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1270"
              />
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1272"
              />
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1274"
              />
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1276"
              />
              <use
                strokeLinecap="round"
                strokeMiterlimit="4"
                strokeWidth="0.529"
                xlinkHref="#path1278"
              />
            </AnimatedSvgGroup>
          </g>
        </g>
      </g>
    </g>
  );
}
